/* ==========================================================================
   SearcherFli > Client > Product
   ========================================================================== */

/* Modules */
const { initOneway, destroyOneway } = require('./oneway');
const { initRoundtrip, destroyRoundtrip } = require('./roundtrip');
const { initOpenjaw, destroyOpenjaw } = require('./openjaw');
const { addRows, destroyRows } = require('./openjaw/rows');

const { OPENJAW } = require('./constants');

const { types, actions } = require('../store/actions');
const { isOpenjaw } = require('../helpers');

/* Init */
function initProduct(instance) {
    const panel = instance;

    /* Actions */
    panel.actions = {
        ...instance.actions,
        changeProduct: payload => {
            /* Save current dates */
            const { product, lastDates, calendar } = instance.store.select('data');

            if (!isOpenjaw(product)) {
                instance.actions.setSearcher({
                    lastDates: {
                        ...lastDates,
                        [product]: calendar instanceof Date ? [calendar] : calendar
                    }
                });
            }

            return instance.store.dispatch(actions.changeProduct(payload));
        }
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        changeProduct: instance.store.subscribe((_, action) => {
            if (action.type !== types.CHANGE_PRODUCT) return;

            if (action.payload === OPENJAW) {
                addRows(instance);
                return;
            }

            destroyRows(instance);

            /* Recover previous dates */
            const { lastDates } = instance.store.select('data');
            if (lastDates[action.payload]) {
                instance.actions.setSearcher({ calendar: lastDates[action.payload] });
                instance.calendar.actions.setValue(lastDates[action.payload]);
                instance.calendar.updateInputValue();
            }
        })
    };

    /* Last calendar dates */
    instance.actions.setSearcher({ lastDates: {} });

    /* Roundtrip */
    initRoundtrip(instance);

    /* Oneway */
    initOneway(instance);

    /* Openjaw */
    initOpenjaw(instance);
}

/* Destroy */
function destroyProduct(instance) {
    const panel = instance;

    /* Actions */
    delete panel.actions.changeProduct;

    /* Roundtrip */
    destroyRoundtrip(instance);

    /* Oneway */
    destroyOneway(instance);

    /* Openjaw */
    destroyOpenjaw(instance);
}

/* Exports */
module.exports = {
    initProduct,
    destroyProduct
};
